import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { createConditionModal } from '../components/modals';
import { MatchingOperator, MatchingStrategy, MatchingSystemType, VariableScope, } from '../components/nodeTypes/types';
const FORM_NAME = 'automationInitForm';
export const DEFAULT_MATCHING_STRATEGY = MatchingStrategy.ANY;
const validate = () => {
    return {};
};
const valueSelect = formValueSelector(FORM_NAME);
const mapStateToProps = () => (state, props) => {
    const { node } = props;
    const initialValues = {
        matchingStrategy: DEFAULT_MATCHING_STRATEGY,
        rules: [
            {
                variable: {
                    scope: VariableScope.SYSTEM,
                    variableType: MatchingSystemType.QUEUE,
                },
                operator: MatchingOperator.EQUALS,
                match: {
                    scope: VariableScope.INPUT,
                    values: [],
                },
            },
        ],
    };
    if (node.payload !== null) {
        if (node.payload.matchingStrategy) {
            initialValues.matchingStrategy = node.payload.matchingStrategy;
        }
        if (node.payload.rules) {
            initialValues.rules = node.payload.rules.map((rule) => {
                return {
                    variable: rule.variable,
                    operator: rule.operator || MatchingOperator.EQUALS,
                    match: rule.match,
                };
            });
        }
    }
    return {
        initialValues,
        matchingStrategy: valueSelect(state, 'matchingStrategy') ||
            initialValues.matchingStrategy,
        rules: valueSelect(state, 'rules') ||
            initialValues.rules,
    };
};
export const createConditionModalContainer = (type, createInitialPayload) => {
    const ConditionalModal = createConditionModal(type, createInitialPayload);
    return connect(mapStateToProps())(reduxForm({
        form: FORM_NAME,
        enableReinitialize: true,
        validate,
    })(ConditionalModal));
};
